import React from 'react';
import {FiMenu, FiShield, FiExternalLink} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Header = ({toggleSidebar, title}) => {
  return (
    <header className="bg-white border-b border-jeruel-grayblue sticky top-0 z-40 px-6 py-4 flex items-center justify-between shadow-sm h-16">
      <div className="flex items-center">
        <button
          onClick={toggleSidebar}
          className="mr-4 lg:hidden text-slate-600 hover:text-slate-900 transition-colors"
        >
          <SafeIcon icon={FiMenu} className="text-2xl" />
        </button>
        <h1 className="text-xl font-bold text-slate-800 tracking-tight">{title}</h1>
      </div>

      <div className="flex items-center space-x-3">
        <div className="hidden md:flex items-center text-xs font-medium text-jeruel-blue bg-jeruel-soft px-3 py-1.5 rounded-full border border-jeruel-grayblue">
          <SafeIcon icon={FiShield} className="mr-2 text-jeruel-blue" />
          <span>Industry Best Practices</span>
        </div>

        <a
          href="https://jeruelglobal.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-sm font-medium text-slate-600 hover:text-jeruel-blue transition-colors px-3 py-1.5 rounded-lg hover:bg-jeruel-soft"
        >
          <span className="hidden sm:inline">Visit Jeruel Global</span>
          <span className="sm:hidden">Jeruel Global</span>
          <SafeIcon icon={FiExternalLink} className="ml-1.5 text-xs" />
        </a>
      </div>
    </header>
  );
};

export default Header;